import { useState } from "react";
import { toast } from "sonner";

type UploadHookResponse = {
  upload: (file: File | undefined) => Promise<string>;
  isUploading: boolean;
  url: string;
  error: string | null;
};

export const useClouldinaryUpload = (
  folder: string,
  tag?: string,
): UploadHookResponse => {
  const [isUploading, setIsUploading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [url, setUrl] = useState<string>("");

  const cloudinary_upload_url = process.env.REACT_APP_CLOUDINARY_UPLOAD_URL!;
  const fd = new FormData();
  fd.append(
    "upload_preset",
    process.env.REACT_APP_CLOUDINARY_UNSIGNED_UPLOAD_PRESET!,
  );
  fd.append("tags", tag ?? "");
  fd.append("timestamp", new Date().toDateString());
  fd.append("folder", folder);

  const upload = async (file: File | undefined): Promise<string> => {
    if (file) {
      fd.append("file", file);
    }

    try {
      setIsUploading(true);
      const response = await fetch(cloudinary_upload_url, {
        method: "POST",
        body: fd,
      });

      const data = await response.json();

      if (response.status !== 200) {
        console.log("error.......");
        throw Error("Ops!, Something went wrong! Try again.");
      }

      setUrl(data?.secure_url);
      setIsUploading(false);
      return data.secure_url;
    } catch (err) {
      const error = err as Error;
      toast.error(error.message);
      setError(error.message);
      setIsUploading(false);
      return "";
    }
  };

  return { upload, isUploading, error, url };
};
